// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .header {
  background-color: #fff;
  padding: 0 20px;
  border-bottom: 1px solid #e3e3e3;
  height: 48px;
  line-height: 48px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
}
.presize-root .review-bar {
  text-align: right;
}
.presize-root .review-bar-progress {
  width: 100px;
}
@media (min-width: 1450px) {
  .presize-root .review-bar-progress {
    width: 200px;
  }
}
.presize-root .hide-reviewed-switch {
  display: block;
  line-height: 22px;
  padding-left: 20px;
  border-left: 1px solid #efeff0;
}
.presize-root .quantities-template-select:not(.ant-select-disabled) .ant-select-selector {
  border-color: #1A1A1A !important;
}
.presize-root .quantities-template-select:not(.ant-select-disabled) .ant-select-arrow {
  color: #1A1A1A;
}
.presize-root .quantities-template-errors-link {
  padding-left: 0;
}
.presize-root .header-selector {
  margin-right: 8px;
  margin-left: 14px;
}
.presize-root .search-box .anticon-search {
  color: #A2A3A8;
  margin-right: 2px;
}
@media (min-width: 1250px) {
  .presize-root .search-box {
    width: 140px;
  }
}
/*# sourceMappingURL=Header.css.map */`, "",{"version":3,"sources":["webpack://./Header.less","webpack://./src/components/Header/Header.less"],"names":[],"mappings":"AAAA;EAEE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;ACAF;ADVA;EAcE,iBAAA;ACDF;ADbA;EAkBE,YAAA;ACFF;ADIE;EAAA;IACE,YAAA;ECDF;AACF;ADrBA;EA0BE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;ACFF;ADME;EAEI,gCAAA;ACLN;ADGE;EAKI,cAAA;ACLN;ADjCA;EA4CE,eAAA;ACRF;ADpCA;EAgDE,iBAAA;EACA,iBAAA;ACTF;ADxCA;EAsDI,cAAA;EACA,iBAAA;ACXJ;ADaE;EAAA;IACE,YAAA;ECVF;AACF;AACA,qCAAqC","sourcesContent":[".presize-root { \n .header {\n  background-color: #fff;\n  padding: 0 20px;\n  border-bottom: 1px solid #e3e3e3;\n  height: 48px;\n  line-height: 48px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.review-bar {\n  text-align: right;\n}\n\n.review-bar-progress {\n  width: 100px;\n\n  @media (min-width: 1450px) {\n    width: 200px;\n  }\n}\n\n.hide-reviewed-switch {\n  display: block;\n  line-height: 22px;\n  padding-left: 20px;\n  border-left: 1px solid #efeff0;\n}\n\n.quantities-template-select {\n  &:not(.ant-select-disabled)  {\n    .ant-select-selector {\n      border-color: #1A1A1A !important; //override border color for consistency in UI\n    }\n    .ant-select-arrow {\n      color: #1A1A1A;\n    }\n  }\n}\n\n.quantities-template-errors-link {\n  padding-left: 0;\n}\n\n.header-selector {\n  margin-right: 8px;\n  margin-left: 14px;\n}\n\n.search-box {\n  .anticon-search {\n    color: #A2A3A8;\n    margin-right: 2px;\n  }\n  @media (min-width: 1250px) {\n    width: 140px;\n  }\n}\n \n}",".presize-root .header {\n  background-color: #fff;\n  padding: 0 20px;\n  border-bottom: 1px solid #e3e3e3;\n  height: 48px;\n  line-height: 48px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n.presize-root .review-bar {\n  text-align: right;\n}\n.presize-root .review-bar-progress {\n  width: 100px;\n}\n@media (min-width: 1450px) {\n  .presize-root .review-bar-progress {\n    width: 200px;\n  }\n}\n.presize-root .hide-reviewed-switch {\n  display: block;\n  line-height: 22px;\n  padding-left: 20px;\n  border-left: 1px solid #efeff0;\n}\n.presize-root .quantities-template-select:not(.ant-select-disabled) .ant-select-selector {\n  border-color: #1A1A1A !important;\n}\n.presize-root .quantities-template-select:not(.ant-select-disabled) .ant-select-arrow {\n  color: #1A1A1A;\n}\n.presize-root .quantities-template-errors-link {\n  padding-left: 0;\n}\n.presize-root .header-selector {\n  margin-right: 8px;\n  margin-left: 14px;\n}\n.presize-root .search-box .anticon-search {\n  color: #A2A3A8;\n  margin-right: 2px;\n}\n@media (min-width: 1250px) {\n  .presize-root .search-box {\n    width: 140px;\n  }\n}\n/*# sourceMappingURL=Header.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
